export default ({ pageType }) => {
  const firstLetter = pageType.charAt(0).toUpperCase();
  const lastPart = pageType.substring(1);

  return `${firstLetter}${lastPart}`
};
